import { useEffect } from 'react';
import useWebSocket from 'react-use-websocket';

const useWSWithTopic = (url, onMessage) => {
  const uri = `${import.meta.env.REACT_APP_WS2}/${url}`;
  const { sendMessage, lastMessage } = useWebSocket(uri, {
    onOpen: () => {
      sendMessage(JSON.stringify({ type: 'SUBSCRIBE' }));
    },
    onClose: () => {
      console.log('WebSocket connection closed');
    },
    shouldReconnect: (_) => true,
    reconnectAttempts: 3,
    heartbeat: {
      message: JSON.stringify({ type: 'PING' }),
      returnMessage: 'pong',
      timeout: 50000,
      interval: 15000,
    },
  });

  useEffect(() => {
    if (lastMessage !== null) {
      if (lastMessage.data === 'pong') return;
      
      try {
        const parsedData = JSON.parse(lastMessage.data);
        const { data } = parsedData;
  
        onMessage(data);
      } catch (error) {
        console.error('Error parsing WebSocket message:', error);
      }
    }
  }, [lastMessage, onMessage]);
};

export default useWSWithTopic;